import React from "react";
import PropTypes from "prop-types";

const ProductLabelDescription = ({ cmsBlock }) => (
  <div
    dangerouslySetInnerHTML={{
      __html: cmsBlock,
    }}
  />
);

ProductLabelDescription.propTypes = {
  cmsBlock: PropTypes.string.isRequired,
};

export default ProductLabelDescription;
